import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { useHistory } from 'react-router-dom';
import { Button } from '../Button';
import Spinner from '../Spinner';
import bookingStore from '../../stores/bookingStores/BookingStore';

export default observer(({ nextStep, prevStep }) => {
    const {
        signingUrl,
        isFetching,
        signed,
        markSigned,
        setHistory,
    } = bookingStore.ratesAcknowledgementStore;
    const history = useHistory();

    const eventHandler = event => {
        const { data } = event;
        if (!data || !data.status) return;

        // Anything other than a completed signature leaves the tenant on this
        // step: the acknowledgement has to be signed before payment.
        if (data.status === 'signing_complete') {
            markSigned();
            nextStep();
        }
    };

    useEffect(() => {
        window.addEventListener('message', eventHandler);
        setHistory(history);
        return () => {
            window.removeEventListener('message', eventHandler);
        };
        // eslint-disable-next-line
    }, []);

    return (
        <div className="rates-acknowledgement-step">
            <h4 className="docusign-title">Acknowledge the Schedule of Rates and Charges</h4>
            {signed ? (
                // Reached by stepping back from Billing. The envelope is already
                // signed, so there is nothing to sign and no message coming.
                <div className="acknowledgement-complete">
                    <p>You have signed the Schedule of Rates and Charges.</p>
                </div>
            ) : (
                    <div className="docusign-container">
                        {isFetching ? (
                            <Spinner />
                        ) : (
                                <iframe
                                    src={signingUrl}
                                    name="ratesAcknowledgement"
                                    title="Rates acknowledgement"
                                    allowFullScreen={true}
                                ></iframe>
                            )}
                    </div>
                )}

            <div className="navigation-btns">
                <Button
                    text="Back"
                    addClass="booking-navigation-btn back"
                    onClick={prevStep}
                />
                {signed && (
                    <Button
                        text="Continue"
                        addClass="booking-navigation-btn continue"
                        onClick={nextStep}
                    />
                )}
            </div>
        </div>
    );
});
